import { render } from "./ReferralInfoOverlay.vue?vue&type=template&id=4ff49145&scoped=true&lang=pug"
import script from "./ReferralInfoOverlay.vue?vue&type=script&lang=js"
export * from "./ReferralInfoOverlay.vue?vue&type=script&lang=js"

import "./ReferralInfoOverlay.vue?vue&type=style&index=0&id=4ff49145&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff49145"]])

export default __exports__